import {SORespAssignedProject} from '../../core/assigned-project/so-resp-assigned-project';
import {AssignedProjectCore} from './assigned-project.core';
import {ListEntry, CEProtocol, CEBase, createCEProtocol, RowSpec} from 'lionheartland';
import {
  DetailEntry, ScopeMatch,
  DetailFactory, DetailFactoryProtocol, EditableType
} from 'lionheartland';
import {BaseDetailType} from 'lionheartland';
import {EntityAttributesForDisplay} from 'lionheartland';
import {getHeading} from 'lionheartland';
import {ListSpecType} from 'lionheartland';
import {DisplayVectorStringFactory} from 'lionheartland';
import {ActiveUserService} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutAssignedProjectFormFields} from './put-assigned-project-form-fields';
import {SOGetAssignedProject} from '../../core/assigned-project/so-get-assigned-project';
import {SOGetPerson} from '../../core/person/so-get-person';
import {SOGetProject} from '../../core/project/so-get-project';
import {SOGetOrganization} from '../../core/organization/so-get-organization';


export class CEAssignedProjectAttributesBase {

    name: DetailEntry
    person: DetailEntry
    project: DetailEntry

    constructor(
        parentEntityViewSpec: EntityViewSpecProtocol,
        entity: SORespAssignedProject,
        app: CommanderApp,
        formFields: PutAssignedProjectFormFields
    ) {

        const displayStringFactory = new DisplayVectorStringFactory(app.displayOptions);
        let heading;


        this.name = new DetailEntry(
            'Name',
            entity.name,
            'name',
            BaseDetailType.text,
            null,
            EditableType.always,
            formFields.name
        )


        const personCore = app.makeCore( 'person');
        personCore.soGet = SOGetPerson.construct({
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        personCore.soGet.queryOptions.sortKey = 'dateCreated';
        personCore.soGet.queryOptions.descending = true;
        let personCeProtocol;
        if (entity.person) {
            personCeProtocol = createCEProtocol(
                personCore.ceProtocol,
                parentEntityViewSpec,
                personCore,
                entity.person,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            personCore
        )
        personCore.title = heading ? heading : personCore.title
        personCore.listTitle = 'Person'

        if (entity.person) {
            displayStringFactory.reconfigure(
                entity.person,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        personCore.configureForDisplay(parentEntityViewSpec)

        this.person = new DetailEntry(
          heading ? heading : personCore.listTitle,
          personCeProtocol ? personCeProtocol.entityListView.fullHeading : null,
          'person',
          BaseDetailType.pushedDetail,
          personCore,
          EditableType.always,
          formFields.person
        )
        if (entity.person) {
          this.person.ceProtocol = personCeProtocol;
          this.person.cachedListEntry = personCore.makeListEntry(parentEntityViewSpec, entity.person, 0)
          personCore.selectedEntity = entity.person;
        }
        this.person.singleFieldSelect = true

        const projectCore = app.makeCore( 'project');
        projectCore.soGet = SOGetProject.construct({
          organization: app.getScope('organization') ? new SOGetOrganization(app.getScope('organization').uid) : null,
        });
        projectCore.soGet.queryOptions.sortKey = 'dateCreated';
        projectCore.soGet.queryOptions.descending = true;
        let projectCeProtocol;
        if (entity.project) {
            projectCeProtocol = createCEProtocol(
                projectCore.ceProtocol,
                parentEntityViewSpec,
                projectCore,
                entity.project,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            projectCore
        )
        projectCore.title = heading ? heading : projectCore.title
        projectCore.listTitle = 'Project'

        if (entity.project) {
            displayStringFactory.reconfigure(
                entity.project,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        projectCore.configureForDisplay(parentEntityViewSpec)

        this.project = new DetailEntry(
          heading ? heading : projectCore.listTitle,
          projectCeProtocol ? projectCeProtocol.entityListView.fullHeading : null,
          'project',
          BaseDetailType.pushedDetail,
          projectCore,
          EditableType.always,
          formFields.project
        )
        if (entity.project) {
          this.project.ceProtocol = projectCeProtocol;
          this.project.cachedListEntry = projectCore.makeListEntry(parentEntityViewSpec, entity.project, 0)
          projectCore.selectedEntity = entity.project;
        }
        this.project.singleFieldSelect = true
    }
}